module.exports = __webpack_public_path__ + "static/media/Kasey M.2daf5481.png";